import axios from 'axios';
import { post_request } from '../axiosFun';

export const get_list = (params) => {
    params = {
        row:{
            name:params.name,
            phone_number:params.phoneNumber,
            job_number:params.jobNumber,
            driving_number:params.drivingNumber,
            page:params.page,
            size:params.limit
        }
    }
    return post_request("/web/driver/get_list",params)
};
export const driver_add = (params) => {
    params = {
        row:{
            name:params.name,
            job_number:params.jobNumber,
            sex:params.sex,
            phone_number:params.phoneNumber,
            driving_number:params.drivingNumber,
            drive_type:params.driveType,
            remarks:params.remarks || ''   
        }
    }
    return post_request("/web/driver/add",params)
};
export const get_one= (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/driver/get_one",params)
};
export const driver_edit = (params) => {
    params = {
        row:{
            id:params.id,
            name:params.name,
            job_number:params.jobNumber,
            sex:params.sex,
            phone_number:params.phoneNumber,
            driving_number:params.drivingNumber,
            drive_type:params.driveType,
            remarks:params.remarks  || ''  
        }
    }
    return post_request("/web/driver/edit",params)
};
export const driver_del = (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/driver/del",params)
};


// WEBPACK FOOTER //
// ./src/api/driver/api.js